// @flow
import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import {
  Title,
  SubHeading,
  StyledP,
  NewLogo,
  YellowPattern,
  GreenPattern,
  Button
} from 'src/theme/globalStyle'
import { media } from 'src/theme/style-utils'
import { StyledFormPage } from 'src/components/Form'
import { Tick } from 'src/components/Icons'
import { BackButton } from 'src/components/BackButton'
import { MindBlown } from 'src/components/Icons'
import type { State } from 'src/types/redux'
import type { Theme as ThemeType } from '../../../../types'

const StyledOops = styled.div`
  max-width: 620px;
  width: 90%;
  border-radius: 3px;
  background-color: #ffffff;
  margin: 120px 0 30px 0;
  display: flex;
  z-index: 10;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  box-shadow: 0px 0px 55px -4px rgb(200, 200, 200);
  ${media.phone`
    padding: 20px;
  `};
  ${media.tablet`
    padding: 20px 40px;
  `};
`

const LogoWrapper = styled(StyledOops)`
  border-radius: 0;
  background-color: transparent;
  align-items: flex-start;
  box-shadow: none;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
`

const StyledThanksP = styled(StyledP)`
  margin: 20px 0;
  text-align: justify;
`

const StyledContactUsText = styled(StyledP)`
  color: #000;
  text-align: center;
  padding: 0;
  font-weight: normal;
`

const StyledList = styled.ul`
  list-style: none;
  margin: 20px 0;
  padding-left: 0;
`

const StyledItem = styled.li`
    display: flex
    align-items: flex-start;
    margin-bottom: 20px;
    & > svg {
      min-width: 16px;
      margin: 4px 10px 0 0;
    }
    & > p {
      font-size: 14px;
      color: ${(props: { theme: ThemeType }) => props.theme.darkText};
      margin: 0;
    }
  }
`

const StyledHeader = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: ${(props: { theme: ThemeType }) => props.theme.darkText};
`

const Oops = ({
  error,
  message,
  canGoBack = true,
  isThankYou = false,
  title = 'Oh no, something went wrong'
}: {
  error: string,
  title?: string,
  message?: string,
  canGoBack?: boolean,
  isThankYou?: boolean
}) => {
  return (
    <StyledFormPage>
      <LogoWrapper>
        <NewLogo style={{ position: 'inherit' }} />
      </LogoWrapper>
      <YellowPattern />
      <GreenPattern />
      <StyledOops>
        <br />
        <br />
        <Title style={{ textAlign: 'center', width: '100%' }}>{title}</Title>
        {!isThankYou && <MindBlown />}
        {error && (
          <SubHeading smaller noMargin style={{ textAlign: 'center' }}>
            {error}
          </SubHeading>
        )}
        {error && (
          <StyledContactUsText>Please contact your sales agent to assist you.</StyledContactUsText>
        )}
        {message && (
          <SubHeading smaller isCentered>
            {message}
          </SubHeading>
        )}
        <br />
        {isThankYou && (
          <div>
            <StyledHeader>
              <Title>Next step...</Title>
            </StyledHeader>
            <StyledThanksP moreMargin smaller>
              You will need to provide us with the following documents within 10 days otherwise we
              will not be able to guarantee you your room.
              <br />
              <br />
              In the event that your move-in date is less than 10 days after completing this form,
              you will need to submit the verification documents at least one day before your
              move-in date.
            </StyledThanksP>
            <StyledList>
              <StyledItem>
                <Tick color="#29dc8d" />
                <p>Passport or other ID</p>
              </StyledItem>
              <StyledItem>
                <Tick color="#29dc8d" />
                <p>Visa if applicable</p>
              </StyledItem>
              <StyledItem>
                <Tick color="#29dc8d" />
                <p>Proof of address</p>
              </StyledItem>
              <StyledItem>
                <Tick color="#29dc8d" />
                <p>Proof of annual income</p>
              </StyledItem>
            </StyledList>
            <StyledThanksP moreMargin smaller>
              Once we have verified your documents and you have set up direct debit, we will provide
              you with your contract.
            </StyledThanksP>
            <br />
            <StyledThanksP moreMargin smaller>
              <Button cssClass="no-print" makeDisabled onClick={() => {}} uppercase>
                Start verification now
              </Button>
            </StyledThanksP>
            <br />
            <br />
          </div>
        )}
        {canGoBack && <BackButton text={'Try again'} />}
      </StyledOops>
    </StyledFormPage>
  )
}

const mapStateToProps = (state: State) => {
  const {
    stripe: { error }
  } = state
  return {
    error
  }
}

export default connect(mapStateToProps, null)(Oops)



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/Oops/index.js